var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.629,
    height: 15.646,
    viewBox: "0 0 24.629 15.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#353841;}.b,.d{fill:none;}.b{stroke:#353841;stroke-width:1.5px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.268,107.8l-1.141-2.479a5.014,5.014,0,0,1,1.454-.215,4.438,4.438,0,0,1,.611.04v-2.482a1.244,1.244,0,0,0-1.3-1.215h-1.53l-.026-2.114a.656.656,0,0,0-.769-.638l-.255.045-2.563.452a.656.656,0,1,0,.228,1.291l2.058-.363.015,1.24a4.957,4.957,0,0,0-2.74,1.142c-1.768,1.511-1.131,2.181-4.336,2.181-1.347,0-3.047-1.941-4.745-2.19a7.468,7.468,0,0,0-3.423.259,3.784,3.784,0,0,0-.558.246,1.5,1.5,0,0,0-.919,1.261c0,.8.744,1.4,1.742,1.851a5.109,5.109,0,0,1,4.507-.794L6.445,107.8l1.206.515,1.13-2.464a5.125,5.125,0,0,1,2.464,4.365h5.228a5.125,5.125,0,0,1,2.458-4.361l1.133,2.462A11.343,11.343,0,0,0,21.268,107.8Zm-14.824,0-.608,1.327-.33.719a.656.656,0,1,0,1.192.546l.367-.8.585-1.276Zm13.619.518.587,1.275.368.8a.656.656,0,0,0,1.191-.548l-.331-.719-.61-1.326C21.375,107.787,20.063,108.318,20.063,108.318Z",
    transform: "translate(-1.332 -98.687)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(15.936 6.954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 4.346,
    cy: 4.346,
    rx: 4.346,
    ry: 4.346
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 4.346,
    cy: 4.346,
    rx: 3.596,
    ry: 3.596
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0.29 6.954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 4.346,
    cy: 4.346,
    rx: 4.346,
    ry: 4.346
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 4.346,
    cy: 4.346,
    rx: 3.596,
    ry: 3.596
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoto);
export default __webpack_public_path__ + "static/media/moto.62ebaca1808ff285e7106e8a49dea4e4.svg";
export { ForwardRef as ReactComponent };